import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const RocketIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      viewBox='0 0 512.00034 512' fill={theme.palette.text.primary}
      height={props.width} width={props.width} xmlns='http://www.w3.org/2000/svg' id='fi_1420462'
    >
      <path
        d='m74.742188 328.078125c-2.898438 5.78125-1.769532 12.769531 2.796874 17.339844l3.667969 3.667969c10.597657-12.558594 22.949219-26.1875 37.929688-41.164063 1.058593-1.058594 2.148437-1.570313 3.210937-2.546875l-23.597656-23.601562c-13.71875 24.8125-21.71875 41.765624-24.007812 46.304687zm0 0'
      />
      <path
        d='m203.988281 392.773438c-15.015625 15.015624-28.609375 27.390624-41.097656 37.996093l4.96875 4.96875c4.609375 4.609375 11.664063 5.71875 17.464844 2.734375 7.769531-4.003906 19.988281-9.753906 45.925781-24.199218l-24.710938-24.710938c-.976562 1.066406-1.488281 2.152344-2.550781 3.210938zm0 0'
      />
      <path
        d='m195.992188 315.9375c-10.839844-10.839844-41.324219-1.121094-55.644532 13.195312-47.90625 47.90625-69.542968 81.871094-79.257812 101.925782-2.785156 5.746094-1.625 12.625 2.890625 17.140625 4.523437 4.527343 11.414062 5.675781 17.164062 2.890625 19.605469-9.519532 53.15625-31.054688 101.632813-79.527344 15.746094-15.753906 23.515625-45.320312 13.226562-55.613281zm0 0'
      />
      <path
        d='m46.820312 199.710938-42.425781 42.425781c-4.796875 4.796875-5.78125 12.222656-2.382812 18.105469 3.316406 5.804687 10.261719 8.761718 16.871093 6.992187 22.929688-6.148437 43.105469-8.746094 56.691407-5.261719 19.328125-34.363281 40.097656-65.996094 62.09375-94.730468-12.722657-8.15625-54.765625-3.613282-90.847657 32.46875zm0 0'
      />
      <path
        d='m253.894531 510.390625c5.777344 2.921875 12.773438 1.792969 17.347657-2.785156l42.429687-42.425781c32.847656-32.855469 38.628906-75.246094 31.175781-88.6875-32.046875 24.152343-64.511718 44.546874-94.800781 61.621093 2.089844 11.800781.699219 23.25-4.242187 56.6875-.964844 6.472657 2.378906 12.734375 8.089843 15.589844zm0 0'
      />
      <path
        d='m297.800781 150.46875c-17.542969 17.546875-17.542969 46.089844 0 63.636719 17.546875 17.546875 46.09375 17.546875 63.640625 0s17.546875-46.089844 0-63.636719-46.09375-17.546875-63.640625 0zm0 0'
      />
      <path
        d='m511.117188 14.632812c-.539063-7.417968-6.445313-13.28125-13.839844-13.835937-36.839844-2.773437-73.535156 1.757813-109.503906 12.757813 2.707031 24.710937 15.488281 51.453124 37.308593 73.273437 22.082031 22.078125 49.550781 34.855469 74.703125 37.246094 9.6875-33.949219 14.28125-70.308594 11.332032-109.441407zm0 0'
      />
      <path
        d='m403.871094 108.042969c-24.960938-24.960938-40.203125-54.898438-45.09375-84.046875-90.074219 36.941406-176.300782 117.613281-244.4375 230.941406l33.851562 33.851562c23.128906-9.390624 51.207032-11.871093 69.015625 5.933594 17.832031 17.835938 15.304688 45.902344 5.917969 69l34.964844 34.964844c87.195312-52.550781 188.710937-135.34375 231.878906-245.496094-29.859375-4.511718-60.730469-19.78125-86.097656-45.148437zm-21.21875 127.277343c-29.238282 29.238282-76.820313 29.238282-106.0625 0-29.242188-29.242187-29.242188-76.828124 0-106.066406 29.242187-29.238281 76.824218-29.238281 106.0625 0 29.242187 29.242188 29.242187 76.824219 0 106.066406zm0 0'
      />
    </svg>
  )
}
export default RocketIcon
